const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #1a5c2a', fontFamily:"'Georgia', serif", color:'#0a1f0e', lineHeight:'1.7', background:'#f2faf4' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2e8b47', paddingBottom:'8px', marginBottom:'24px', color:'#145a24' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#1e7a36', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2e8b47', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#e8f5ec', border:'2px solid #2e8b47', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#145a24', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2e8b47' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#1e7a36', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#edf7f0' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#145a24', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f4fbf6', border:'1px solid #b6dfc0', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#145a24', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#3a7a4a', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Details</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Tube Hydroforming Cross-Section Process ────────────────
function DiagramTubeHydroforming() {
  const W = 900, H = 410;
  // Layout constants — one column per stage, equal width
  const stageW = 190, gap = 30;
  // Stage centres
  const cx = [105, 315, 525, 735];
  // Vertical positions
  const labelY = 18, dieTopY = 28, dieBotY = 190, dieH = 52, midY = 140;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Tube Hydroforming — Process Stages</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowGreen" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#1e7a36" opacity="0.85"/>
          </marker>
          <marker id="arrowOrange" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#e07b00" opacity="0.9"/>
          </marker>
          <linearGradient id="dieGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#c8d6db"/>
            <stop offset="100%" stopColor="#78909c"/>
          </linearGradient>
          <linearGradient id="fluidGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#52b96a" stopOpacity="0.8"/>
            <stop offset="100%" stopColor="#1e7a36" stopOpacity="0.95"/>
          </linearGradient>
        </defs>

        {/* ── Stage arrows (drawn first, behind content) ── */}
        {[0,1,2].map(i => (
          <line key={i}
            x1={cx[i]+stageW/2-5} y1={midY}
            x2={cx[i+1]-stageW/2+10} y2={midY}
            stroke="#1e7a36" strokeWidth="2.5" markerEnd="url(#arrowGreen)"/>
        ))}

        {/* ── Stage 1: Load Tube ── */}
        <text x={cx[0]} y={labelY} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">① Load Tube</text>
        <rect x={cx[0]-stageW/2} y={dieTopY} width={stageW} height={dieH} rx={3} fill="url(#dieGrad)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={cx[0]} y={dieTopY+30} textAnchor="middle" fontSize="11" fill="#fff">Upper Die</text>
        <rect x={cx[0]-stageW/2} y={dieBotY} width={stageW} height={dieH} rx={3} fill="url(#dieGrad)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={cx[0]} y={dieBotY+30} textAnchor="middle" fontSize="11" fill="#fff">Lower Die</text>
        {/* Round tube — centred in gap between dies */}
        <ellipse cx={cx[0]} cy={midY} rx={30} ry={30} fill="none" stroke="#1a5c2a" strokeWidth="4"/>
        <ellipse cx={cx[0]} cy={midY} rx={23} ry={23} fill="#e8f5ec"/>
        <text x={cx[0]} y={midY+48} textAnchor="middle" fontSize="10" fill="#1a5c2a" fontStyle="italic">round tube</text>

        {/* ── Stage 2: Close Die ── */}
        <text x={cx[1]} y={labelY} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">② Close Die</text>
        {/* Upper die — closer to centre */}
        <rect x={cx[1]-stageW/2} y={dieTopY} width={stageW} height={dieH} rx={3} fill="url(#dieGrad)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={cx[1]} y={dieTopY+30} textAnchor="middle" fontSize="11" fill="#fff">Upper Die</text>
        {/* Lower die */}
        <rect x={cx[1]-stageW/2} y={dieBotY} width={stageW} height={dieH} rx={3} fill="url(#dieGrad)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={cx[1]} y={dieBotY+30} textAnchor="middle" fontSize="11" fill="#fff">Lower Die</text>
        {/* Tube trapped in closed die */}
        <rect x={cx[1]-60} y={dieTopY+dieH} width={120} height={dieBotY-(dieTopY+dieH)} rx={2} fill="#c6efce" stroke="#1a5c2a" strokeWidth="2"/>
        <rect x={cx[1]-54} y={dieTopY+dieH+6} width={108} height={dieBotY-(dieTopY+dieH)-12} rx={1} fill="#e8f5ec"/>
        {/* Die-close arrows */}
        <line x1={cx[1]} y1={dieTopY+dieH+8} x2={cx[1]} y2={dieTopY+dieH+22} stroke="#546e7a" strokeWidth="1.5" markerEnd="url(#arrowGreen)" opacity="0.5"/>
        <line x1={cx[1]} y1={dieBotY-8} x2={cx[1]} y2={dieBotY-22} stroke="#546e7a" strokeWidth="1.5" markerEnd="url(#arrowGreen)" opacity="0.5" transform={`rotate(180 ${cx[1]} ${dieBotY-15})`}/>

        {/* ── Stage 3: Pressurize + Feed ── */}
        <text x={cx[2]} y={labelY} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">③ Pressurize + Feed</text>
        <rect x={cx[2]-stageW/2} y={dieTopY} width={stageW} height={dieH} rx={3} fill="url(#dieGrad)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={cx[2]} y={dieTopY+30} textAnchor="middle" fontSize="11" fill="#fff">Upper Die</text>
        <rect x={cx[2]-stageW/2} y={dieBotY} width={stageW} height={dieH} rx={3} fill="url(#dieGrad)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={cx[2]} y={dieBotY+30} textAnchor="middle" fontSize="11" fill="#fff">Lower Die</text>
        {/* Fluid-filled tube */}
        <rect x={cx[2]-60} y={dieTopY+dieH} width={120} height={dieBotY-(dieTopY+dieH)} rx={2} fill="url(#fluidGrad)" stroke="#1a5c2a" strokeWidth="2"/>
        <text x={cx[2]} y={midY-6} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">High-pressure</text>
        <text x={cx[2]} y={midY+8} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">fluid</text>
        <text x={cx[2]} y={midY+22} textAnchor="middle" fontSize="9" fill="#d4f0da">~70–400 MPa</text>
        {/* Left punch — sits outside die edge, arrow points right into tube */}
        <rect x={cx[2]-stageW/2-44} y={midY-16} width={40} height={32} rx={2} fill="#e07b00" stroke="#bf6000" strokeWidth="1.5"/>
        <text x={cx[2]-stageW/2-24} y={midY-2} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">Punch</text>
        <text x={cx[2]-stageW/2-24} y={midY+10} textAnchor="middle" fontSize="9" fill="#fff">→</text>
        <line x1={cx[2]-stageW/2-4} y1={midY} x2={cx[2]-stageW/2+6} y2={midY} stroke="#e07b00" strokeWidth="2" markerEnd="url(#arrowOrange)"/>
        {/* Right punch */}
        <rect x={cx[2]+stageW/2+4} y={midY-16} width={40} height={32} rx={2} fill="#e07b00" stroke="#bf6000" strokeWidth="1.5"/>
        <text x={cx[2]+stageW/2+24} y={midY-2} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">Punch</text>
        <text x={cx[2]+stageW/2+24} y={midY+10} textAnchor="middle" fontSize="9" fill="#fff">←</text>
        <line x1={cx[2]+stageW/2+4} y1={midY} x2={cx[2]+stageW/2-6} y2={midY} stroke="#e07b00" strokeWidth="2" markerEnd="url(#arrowOrange)"/>

        {/* ── Stage 4: Final Part ── */}
        <text x={cx[3]} y={labelY} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">④ Final Part</text>
        <rect x={cx[3]-stageW/2} y={dieTopY} width={stageW} height={dieH} rx={3} fill="url(#dieGrad)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={cx[3]} y={dieTopY+30} textAnchor="middle" fontSize="11" fill="#fff">Upper Die</text>
        <rect x={cx[3]-stageW/2} y={dieBotY} width={stageW} height={dieH} rx={3} fill="url(#dieGrad)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={cx[3]} y={dieBotY+30} textAnchor="middle" fontSize="11" fill="#fff">Lower Die</text>
        {/* Formed shape — contained within die gap, well within bounds */}
        {(()=>{
          const lx = cx[3]-58, rx = cx[3]+58;
          const ty = dieTopY+dieH+2, by = dieBotY-2;
          const drop = 22;
          return <>
            <path d={`M ${lx},${ty} L ${rx},${ty} L ${rx},${ty+8} Q ${cx[3]+30},${ty+drop} ${cx[3]+14},${by-6} Q ${cx[3]},${by} ${cx[3]-14},${by-6} Q ${cx[3]-30},${ty+drop} ${lx},${ty+8} Z`}
                  fill="#1a5c2a" stroke="#145a24" strokeWidth="1.5"/>
            <path d={`M ${lx+5},${ty+3} L ${rx-5},${ty+3} L ${rx-5},${ty+9} Q ${cx[3]+26},${ty+drop-2} ${cx[3]+12},${by-9} Q ${cx[3]},${by-4} ${cx[3]-12},${by-9} Q ${cx[3]-26},${ty+drop-2} ${lx+5},${ty+9} Z`}
                  fill="#52b96a"/>
            <text x={cx[3]} y={midY-4} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">formed shape</text>
            <text x={cx[3]} y={dieBotY+dieH+14} textAnchor="middle" fontSize="10" fill="#1e7a36">complex cross-section</text>
          </>;
        })()}

        {/* ── Key Parameters box ── */}
        <rect x={10} y={260} width={880} height={138} rx={5} fill="#fff" stroke="#b6dfc0"/>
        <text x={450} y={280} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Key Parameters</text>
        {[
          {x:30,  label:"Internal pressure",   val:"70 – 400 MPa"},
          {x:210, label:"Axial feed force",     val:"Up to 10 MN"},
          {x:390, label:"Fluid medium",         val:"Water / oil emulsion"},
          {x:580, label:"Typical wall thinning",val:"< 10% of original"},
          {x:748, label:"Expansion ratio",      val:"Up to 30%"},
        ].map(({x,label,val}) => (
          <g key={x}>
            <text x={x+10} y={310} fontSize="11" fill="#546e7a">{label}</text>
            <text x={x+10} y={330} fontSize="13" fill="#145a24" fontWeight="700">{val}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Tube hydroforming: a hollow tube is loaded into a die, the die is closed under press force, then high-pressure hydraulic fluid expands the tube to fill the die cavity. Axial punches simultaneously feed material to prevent thinning, allowing complex cross-sections impossible with conventional forming.</div>
    </div>
  );
}

// ── Diagram 2: Sheet Hydroforming ──────────────────────────────────
function DiagramSheetHydroforming() {
  const W = 900, H = 400;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Sheet Hydroforming — Fluid Cell vs. Punch Hydroforming</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="sg1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#c8d6db"/>
            <stop offset="100%" stopColor="#78909c"/>
          </linearGradient>
          <linearGradient id="fluid2" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor="#1e7a36" stopOpacity="0.9"/>
            <stop offset="100%" stopColor="#52b96a" stopOpacity="0.65"/>
          </linearGradient>
          <marker id="arrowG2" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#145a24"/>
          </marker>
          <marker id="arrowG2down" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
        </defs>

        {/* ─── LEFT PANEL: Fluid Cell ─── */}
        <rect x={8} y={8} width={428} height={386} rx={6} fill="#fff" stroke="#b6dfc0" strokeWidth="1.5"/>
        <text x={222} y={30} textAnchor="middle" fontSize="14" fill="#145a24" fontWeight="700">Fluid Cell (Rubber Diaphragm) Process</text>

        {/* Fluid chamber */}
        <rect x={30} y={42} width={384} height={74} rx={4} fill="url(#sg1)" stroke="#546e7a" strokeWidth="1.5"/>
        <rect x={40} y={52} width={364} height={54} rx={3} fill="url(#fluid2)"/>
        <text x={222} y={78} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">Pressurised Fluid Chamber</text>
        <text x={222} y={95} textAnchor="middle" fontSize="11" fill="#d4f0da">~100 – 1400 bar</text>

        {/* Pressure arrows down through diaphragm */}
        {[80,140,200,260,320,380].map(x => (
          <line key={x} x1={x} y1={116} x2={x} y2={132} stroke="#fff" strokeWidth="1.5" strokeDasharray="3,2" markerEnd="url(#arrowG2)" opacity="0.65"/>
        ))}

        {/* Rubber diaphragm */}
        <path d="M 30,136 Q 222,154 414,136" fill="none" stroke="#e07b00" strokeWidth="4"/>
        <text x={222} y={166} textAnchor="middle" fontSize="11" fill="#e07b00" fontWeight="700">Rubber Diaphragm (flexible membrane)</text>

        {/* Sheet blank */}
        <rect x={58} y={174} width={308} height={10} rx={2} fill="#1a5c2a" stroke="#145a24" strokeWidth="1"/>
        <text x={376} y={183} fontSize="10" fill="#1a5c2a" fontStyle="italic">sheet blank</text>

        {/* Form tool / punch block */}
        <path d="M 78,184 L 158,184 L 158,202 Q 178,238 222,240 Q 266,238 286,202 L 286,184 L 366,184 L 366,260 L 78,260 Z"
              fill="url(#sg1)" stroke="#546e7a" strokeWidth="1.5"/>
        <text x={222} y={235} textAnchor="middle" fontSize="11" fill="#fff">Form Tool / Punch</text>

        {/* Blank holders */}
        <rect x={28} y={258} width={52} height={20} rx={2} fill="#78909c" stroke="#546e7a"/>
        <rect x={364} y={258} width={52} height={20} rx={2} fill="#78909c" stroke="#546e7a"/>
        <text x={54} y={272} textAnchor="middle" fontSize="9" fill="#fff">blank holder</text>
        <text x={390} y={272} textAnchor="middle" fontSize="9" fill="#fff">blank holder</text>

        {/* How it works box */}
        <rect x={28} y={292} width={388} height={88} rx={3} fill="#e8f5ec" stroke="#1e7a36" strokeWidth="1"/>
        <text x={38} y={310} fontSize="11" fill="#145a24" fontWeight="700">How it works:</text>
        <text x={38} y={328} fontSize="11" fill="#444">• Sheet placed over a positive punch / form tool</text>
        <text x={38} y={346} fontSize="11" fill="#444">• Fluid pushes diaphragm down, wrapping sheet</text>
        <text x={38} y={364} fontSize="11" fill="#444">  over tool contour</text>
        <text x={38} y={374} fontSize="11" fill="#444">• No lower die needed — one-sided tooling only</text>

        {/* ─── RIGHT PANEL: Punch Hydroforming ─── */}
        <rect x={444} y={8} width={450} height={386} rx={6} fill="#fff" stroke="#b6dfc0" strokeWidth="1.5"/>
        <text x={669} y={30} textAnchor="middle" fontSize="14" fill="#145a24" fontWeight="700">Punch (Active Fluid) Hydroforming</text>

        {/* Punch block */}
        <rect x={619} y={48} width={100} height={90} rx={4} fill="#e07b00" stroke="#bf6000" strokeWidth="1.5"/>
        <text x={669} y={97} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">Punch</text>

        {/* Press force arrow + label — below punch, above sheet */}
        <line x1={669} y1={140} x2={669} y2={157} stroke="#c0392b" strokeWidth="3" markerEnd="url(#arrowG2down)"/>
        <text x={700} y={152} fontSize="11" fill="#c0392b" fontWeight="700">press force</text>

        {/* Blank holders */}
        <rect x={456} y={162} width={66} height={26} rx={2} fill="#78909c" stroke="#546e7a"/>
        <rect x={816} y={162} width={66} height={26} rx={2} fill="#78909c" stroke="#546e7a"/>
        <text x={489} y={179} textAnchor="middle" fontSize="10" fill="#fff">BH</text>
        <text x={849} y={179} textAnchor="middle" fontSize="10" fill="#fff">BH</text>

        {/* Sheet */}
        <rect x={456} y={186} width={432} height={10} rx={2} fill="#1a5c2a" stroke="#145a24" strokeWidth="1.5"/>

        {/* Fluid cavity */}
        <rect x={456} y={210} width={432} height={100} rx={4} fill="url(#sg1)" stroke="#546e7a" strokeWidth="1.5"/>
        <rect x={470} y={220} width={404} height={80} rx={3} fill="url(#fluid2)"/>
        <text x={669} y={262} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">Pressurised Fluid (die cavity)</text>
        <text x={669} y={280} textAnchor="middle" fontSize="11" fill="#d4f0da">counter-pressure: 50 – 400 bar</text>

        {/* Fluid pressure arrows upward */}
        {[510,570,640,710,780,840].map(x => (
          <line key={x} x1={x} y1={216} x2={x} y2={200} stroke="#fff" strokeWidth="1.5" strokeDasharray="3,2" markerEnd="url(#arrowG2)" opacity="0.65"/>
        ))}

        {/* How it works box */}
        <rect x={456} y={326} width={432} height={60} rx={3} fill="#e8f5ec" stroke="#1e7a36" strokeWidth="1"/>
        <text x={466} y={344} fontSize="11" fill="#145a24" fontWeight="700">How it works:</text>
        <text x={466} y={362} fontSize="11" fill="#444">• Punch descends into fluid-filled die; fluid provides counter-pressure</text>
        <text x={466} y={378} fontSize="11" fill="#444">  → tight radii, excellent surface finish, minimal springback</text>
      </svg>
      <div style={S.dCaption}>Sheet hydroforming uses hydraulic pressure to form flat blanks. Fluid cell uses a flexible diaphragm against a single punch — ideal for complex contours without a matched lower die. Punch hydroforming uses fluid counter-pressure beneath the sheet to control springback, improve surface quality, and achieve tighter radii than conventional deep drawing.</div>
    </div>
  );
}

// ── Diagram 3: Pressure–Feed Loading Path ─────────────────────────
function DiagramLoadingPath() {
  const W = 920, H = 360;
  // Chart bounds
  const cL = 90, cR = 620, cT = 20, cB = 290;
  const cW = cR - cL, cH = cB - cT;
  // Scale helpers: feed 0–70mm → x; pressure 0–250MPa → y
  const fx = f => cL + (f/70)*cW;
  const py = p => cB - (p/250)*cH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Tube Hydroforming — Pressure / Axial Feed Loading Path &amp; Failure Modes</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="axArr" markerWidth="9" markerHeight="9" refX="7" refY="4.5" orient="auto">
            <polygon points="0 0, 8 4.5, 0 9" fill="#333"/>
          </marker>
        </defs>

        {/* Chart background */}
        <rect x={cL} y={cT} width={cW} height={cH} rx={3} fill="#f4fbf6" stroke="#b6dfc0"/>

        {/* Grid lines */}
        {[50,100,150,200].map(p => (
          <line key={p} x1={cL} y1={py(p)} x2={cR} y2={py(p)} stroke="#b6dfc0" strokeWidth="1" strokeDasharray="5,4"/>
        ))}
        {[10,20,30,40,50,60].map(f => (
          <line key={f} x1={fx(f)} y1={cT} x2={fx(f)} y2={cB} stroke="#b6dfc0" strokeWidth="1" strokeDasharray="5,4"/>
        ))}

        {/* ── Failure zones ── */}
        {/* BURST — top-left: high pressure, low feed */}
        <path d={`M ${cL},${py(250)} L ${cL},${cT} L ${fx(18)},${cT} L ${fx(18)},${py(180)} Q ${fx(12)},${py(190)} ${cL},${py(200)} Z`}
              fill="#c0392b" opacity="0.11"/>
        <text x={cL+8} y={py(240)} fontSize="12" fill="#c0392b" fontWeight="700">BURST</text>
        <text x={cL+8} y={py(224)} fontSize="10" fill="#c0392b">(fracture)</text>

        {/* WRINKLE — bottom-right: high feed, low pressure */}
        <path d={`M ${cL},${cB} L ${fx(62)},${cB} L ${fx(62)},${py(40)} Q ${fx(40)},${py(20)} ${fx(20)},${py(10)} Q ${fx(10)},${py(6)} ${cL},${cB} Z`}
              fill="#e07b00" opacity="0.11"/>
        <text x={fx(28)} y={py(15)} fontSize="12" fill="#e07b00" fontWeight="700">WRINKLE / BUCKLE</text>
        <text x={fx(30)} y={py(2)} fontSize="10" fill="#e07b00">(excess feed)</text>

        {/* THINNING — top-right */}
        <path d={`M ${fx(52)},${cT} L ${cR},${cT} L ${cR},${py(130)} Q ${fx(62)},${py(160)} ${fx(52)},${py(180)} Z`}
              fill="#2a6a3a" opacity="0.11"/>
        <text x={fx(54)} y={py(230)} fontSize="12" fill="#2a6a3a" fontWeight="700">THINNING</text>
        <text x={fx(56)} y={py(215)} fontSize="10" fill="#2a6a3a">(necking)</text>

        {/* ── Optimal loading path ── */}
        <path d={`M ${fx(0)},${py(0)} Q ${fx(10)},${py(60)} ${fx(20)},${py(110)} Q ${fx(35)},${py(160)} ${fx(48)},${py(195)} Q ${fx(56)},${py(212)} ${fx(63)},${py(220)}`}
              fill="none" stroke="#1e7a36" strokeWidth="3"/>
        {/* Label anchored left of the curve end, inside chart */}
        <text x={fx(35)} y={py(178)} fontSize="12" fill="#1e7a36" fontWeight="700">Optimal Path</text>

        {/* Calibration annotation — placed at ~55mm / 205MPa, clear of zones */}
        <circle cx={fx(53)} cy={py(207)} r={5} fill="#27ae60"/>
        <line x1={fx(53)} y1={py(207)} x2={fx(43)} y2={py(240)} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="4,3"/>
        <text x={fx(38)} y={py(248)} fontSize="10" fill="#27ae60" fontWeight="700">Calibration</text>
        <text x={fx(38)} y={py(236)} fontSize="10" fill="#27ae60">phase start</text>

        {/* ── Axes ── */}
        <line x1={cL} y1={cB} x2={cR+14} y2={cB} stroke="#333" strokeWidth="2" markerEnd="url(#axArr)"/>
        <line x1={cL} y1={cB} x2={cL} y2={cT-14} stroke="#333" strokeWidth="2" markerEnd="url(#axArr)"/>

        {/* Axis tick labels */}
        {[0,10,20,30,40,50,60].map(f => (
          <text key={f} x={fx(f)} y={cB+16} textAnchor="middle" fontSize="10" fill="#555">{f}</text>
        ))}
        {[0,50,100,150,200].map(p => (
          <text key={p} x={cL-6} y={py(p)+4} textAnchor="end" fontSize="10" fill="#555">{p}</text>
        ))}

        {/* Axis labels */}
        <text x={cL + cW/2} y={cB+32} textAnchor="middle" fontSize="13" fill="#333">Axial Feed (mm) →</text>
        <text x={18} y={cT + cH/2} textAnchor="middle" fontSize="13" fill="#333" transform={`rotate(-90 18 ${cT+cH/2})`}>Internal Pressure (MPa) →</text>

        {/* ── Right legend panel ── */}
        <rect x={636} y={cT} width={272} height={cH} rx={5} fill="#fff" stroke="#b6dfc0"/>
        <text x={772} y={cT+22} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Loading Path Zones</text>

        {[
          {y:cT+32, bg:"#FEF0F0", bc:"#c0392b", lines:["BURST / FRACTURE","Pressure too high, feed","too low → tube ruptures"]},
          {y:cT+112, bg:"#fff5e6", bc:"#e07b00", lines:["WRINKLE / BUCKLE","Axial feed too high,","pressure too low → wall buckles"]},
          {y:cT+192, bg:"#dff0e4", bc:"#2e8b47", lines:["THINNING / NECK","Pressure high, feed low","→ localised wall thinning"]},
        ].map(({y,bg,bc,lines}) => (
          <g key={y}>
            <rect x={644} y={y} width={256} height={68} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
            {lines.map((ln, i) => (
              <text key={i} x={652} y={y+18+i*16} fontSize="11" fill={i===0?"#333":"#555"} fontWeight={i===0?"700":"400"}>{ln}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The loading path (internal pressure vs. axial feed over time) must stay within a process window to produce a defect-free part. Too much pressure without sufficient feed causes burst fracture; too much feed without pressure causes wrinkling; insufficient feed at high pressure causes wall thinning and necking. FEA simulation is used to optimise the loading path before tooling is built.</div>
    </div>
  );
}

// ── Diagram 4: Applications & Industries ─────────────────────────
function DiagramApplications() {
  const W = 900, H = 310;
  const apps = [
    { icon:'🚗', sector:'Automotive', color:'#1a5c2a', bg:'#e8f5ec', bc:'#1a5c2a',
      parts:['A-pillars & roof rails','Exhaust manifolds','Cradle / sub-frame rails','Engine mounts','Suspension arms'] },
    { icon:'✈️', sector:'Aerospace', color:'#0d5e2e', bg:'#e8f5e9', bc:'#2e7d32',
      parts:['Titanium ducting','Fuselage frames','Hydraulic manifolds','Structural brackets','Nacelle components'] },
    { icon:'🏗️', sector:'Structural', color:'#145a24', bg:'#e8f5ec', bc:'#1a5c2a',
      parts:['Bicycle frames','Architectural tubing','Space-frame joints','Handrails / banisters','Furniture tubes'] },
    { icon:'⚙️', sector:'Industrial', color:'#bf6000', bg:'#fff8e1', bc:'#f57f17',
      parts:['Hydraulic fittings','Heat exchanger tubes','Pressure vessel heads','Pump housings','Manifold blocks'] },
    { icon:'🏥', sector:'Medical', color:'#b71c1c', bg:'#ffebee', bc:'#c62828',
      parts:['Surgical instrument shafts','Endoscope housings','Implant components','Catheter guides','Stent preforms'] },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Hydroforming — Industrial Applications by Sector</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {apps.map(({icon,sector,color,bg,bc,parts}, i) => {
          const x = 18 + i * 176;
          return (
            <g key={sector}>
              <rect x={x} y={10} width={162} height={285} rx={6} fill={bg} stroke={bc} strokeWidth="1.5"/>
              <text x={x+81} y={42} textAnchor="middle" fontSize="26">{icon}</text>
              <rect x={x+8} y={52} width={146} height={26} rx={3} fill={bc} opacity="0.9"/>
              <text x={x+81} y={70} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">{sector}</text>
              {parts.map((p, j) => (
                <g key={j}>
                  <circle cx={x+18} cy={96+j*42} r={4} fill={color} opacity="0.7"/>
                  <text x={x+26} y={92+j*42} fontSize="11" fill="#222">{p.length > 20 ? p.slice(0,20)+'…' : p}</text>
                  {p.length > 20 && <text x={x+26} y={106+j*42} fontSize="10" fill="#555">{p.slice(20)}</text>}
                </g>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Hydroforming is used across sectors wherever lightweight, high-strength hollow components with complex geometry are needed. Automotive is by far the largest market — structural body-in-white and chassis components formed by hydroforming achieve 25–40% mass reduction versus stamped-and-welded assemblies while improving stiffness and reducing part count.</div>
    </div>
  );
}

// ── Diagram 5: Comparison — Hydroforming vs Conventional Processes ─
function DiagramComparison() {
  const W = 900, H = 300;
  const cats = ['Part complexity','Weight reduction','Surface quality','Tooling cost','Cycle time','Material waste','Weld joints needed','Dimensional accuracy'];
  const hf =   [90, 85, 88, 30, 40, 78, 95, 87];
  const stamp = [50, 45, 60, 85, 90, 45, 30, 60];
  const extr =  [45, 70, 72, 65, 75, 60, 55, 68];

  const BAR_H = 22, GAP = 10, GROUP = 3*BAR_H + 2*GAP + 18;
  const chartX = 200, chartW = 630;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Hydroforming vs Stamping vs Extrusion — Capability Comparison</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Legend */}
        <rect x={200} y={6} width={14} height={10} fill="#1e7a36"/>
        <text x={218} y={16} fontSize="11" fill="#145a24" fontWeight="700">Hydroforming</text>
        <rect x={360} y={6} width={14} height={10} fill="#e07b00" opacity="0.8"/>
        <text x={378} y={16} fontSize="11" fill="#e07b00" fontWeight="700">Stamping</text>
        <rect x={480} y={6} width={14} height={10} fill="#27ae60" opacity="0.8"/>
        <text x={498} y={16} fontSize="11" fill="#27ae60" fontWeight="700">Extrusion</text>
        <text x={650} y={16} fontSize="10" fill="#888" fontStyle="italic">(bar = relative score, higher = better)</text>

        {cats.map((cat, i) => {
          const baseY = 24 + i * 32;
          return (
            <g key={cat}>
              <text x={190} y={baseY + BAR_H/2 + 4} textAnchor="end" fontSize="11" fill="#145a24">{cat}</text>
              {/* HF bar */}
              <rect x={chartX} y={baseY} width={hf[i]/100*chartW} height={BAR_H} rx={3} fill="#1e7a36" opacity="0.85"/>
              <text x={chartX + hf[i]/100*chartW + 4} y={baseY+15} fontSize="10" fill="#1e7a36" fontWeight="700">{hf[i]}</text>
              {/* Stamp bar */}
              <rect x={chartX} y={baseY+BAR_H*0.3} width={stamp[i]/100*chartW*0.7} height={BAR_H*0.5} rx={2} fill="#e07b00" opacity="0.5"/>
              <text x={chartX + stamp[i]/100*chartW*0.7 + 4} y={baseY+BAR_H*0.3+10} fontSize="9" fill="#e07b00">{stamp[i]}</text>
            </g>
          );
        })}

        {/* Vertical axis */}
        <line x1={chartX} y1={20} x2={chartX} y2={H-10} stroke="#b6dfc0" strokeWidth="1"/>
        {[0,25,50,75,100].map(v => (
          <g key={v}>
            <line x1={chartX + v/100*chartW} y1={20} x2={chartX + v/100*chartW} y2={H-10} stroke="#b6dfc0" strokeWidth="1" strokeDasharray="3,2"/>
            <text x={chartX + v/100*chartW} y={H-2} textAnchor="middle" fontSize="9" fill="#999">{v}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>Hydroforming outperforms conventional stamping in geometric complexity, surface finish, dimensional precision, and weight reduction. Stamping wins on cycle time and tooling cost. Extrusion excels for prismatic constant-section profiles. Selection depends on production volume, part geometry, and material.</div>
    </div>
  );
}

// ── Diagram 6: Stress State & Material Flow ────────────────────────
function DiagramStressState() {
  const W = 900, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Stress State & Material Flow During Tube Hydroforming</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="ax3" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#c0392b"/>
          </marker>
          <marker id="axG" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#27ae60"/>
          </marker>
          <marker id="axB" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 8" fill="#1e7a36"/>
          </marker>
        </defs>

        {/* ─── Left: stress state diagram on tube element ─── */}
        <rect x={10} y={10} width={380} height={295} rx={5} fill="#fff" stroke="#b6dfc0"/>
        <text x={200} y={30} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Stress Components on Tube Wall Element</text>

        {/* Tube wall element cube */}
        {(()=>{
          const cx=200, cy=170, s=60, sk=20;
          const pts = {
            fl:`${cx-s},${cy+s}`, fr:`${cx+s},${cy+s}`, br:`${cx+s+sk},${cy+s-sk}`,
            bl:`${cx-s+sk},${cy+s-sk}`, tl:`${cx-s},${cy-s}`, tr:`${cx+s},${cy-s}`,
            tbr:`${cx+s+sk},${cy-s-sk}`, tbl:`${cx-s+sk},${cy-s-sk}`,
          };
          return <>
            {/* cube faces */}
            <polygon points={`${pts.fl} ${pts.fr} ${pts.tr} ${pts.tl}`} fill="#e8f5ec" stroke="#1a5c2a" strokeWidth="1.5"/>
            <polygon points={`${pts.fr} ${pts.br} ${pts.tbr} ${pts.tr}`} fill="#c6efce" stroke="#1a5c2a" strokeWidth="1.5"/>
            <polygon points={`${pts.tr} ${pts.tbr} ${pts.tbl} ${pts.tl}`} fill="#a8d5b0" stroke="#1a5c2a" strokeWidth="1.5"/>

            {/* σ_θ — hoop stress (horizontal, red) */}
            <line x1={cx-s-28} y1={cy} x2={cx-s} y2={cy} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#ax3)"/>
            <line x1={cx+s+28} y1={cy} x2={cx+s} y2={cy} stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#ax3)"/>
            <text x={cx-s-50} y={cy-6} fontSize="12" fill="#c0392b" fontWeight="700">σ_θ</text>
            <text x={cx+s+32} y={cy-6} fontSize="12" fill="#c0392b" fontWeight="700">σ_θ</text>
            <text x={cx} y={cy+92} textAnchor="middle" fontSize="11" fill="#c0392b">Hoop stress (circumferential)</text>

            {/* σ_z — axial stress (vertical, green) */}
            <line x1={cx} y1={cy-s-28} x2={cx} y2={cy-s} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#axG)"/>
            <line x1={cx} y1={cy+s+28} x2={cx} y2={cy+s} stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#axG)"/>
            <text x={cx+8} y={cy-s-30} fontSize="12" fill="#27ae60" fontWeight="700">σ_z</text>
            <text x={cx+8} y={cy+s+36} fontSize="12" fill="#27ae60" fontWeight="700">σ_z</text>

            {/* σ_r — radial stress (diagonal, blue) */}
            <line x1={cx+sk+28} y1={cy-sk-28} x2={cx+sk+8} y2={cy-sk-8} stroke="#1e7a36" strokeWidth="2.5" markerEnd="url(#axB)"/>
            <text x={cx+sk+34} y={cy-sk-28} fontSize="12" fill="#1e7a36" fontWeight="700">σ_r</text>
            <text x={cx} y={cy+106} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">(radial, compressive — equals −p_internal)</text>
          </>;
        })()}

        {/* Formula boxes bottom-left */}
        <rect x={18} y={242} width={365} height={55} rx={3} fill="#e8f5ec" stroke="#1e7a36"/>
        <text x={26} y={258} fontSize="11" fill="#145a24" fontWeight="700">Hoop stress (thin-wall):  σ_θ = p·r / t</text>
        <text x={26} y={274} fontSize="11" fill="#444">p = internal pressure, r = mean radius, t = wall thickness</text>
        <text x={26} y={288} fontSize="11" fill="#444">Von Mises yield criterion governs onset of plastic flow</text>

        {/* ─── Right: FLD (Forming Limit Diagram) sketch ─── */}
        <rect x={400} y={10} width={490} height={295} rx={5} fill="#fff" stroke="#b6dfc0"/>
        <text x={645} y={30} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Forming Limit Diagram (FLD)</text>

        {/* Axes */}
        <line x1={440} y1={260} x2={860} y2={260} stroke="#333" strokeWidth="1.5"/>
        <line x1={440} y1={260} x2={440} y2={45} stroke="#333" strokeWidth="1.5"/>
        <text x={650} y={282} textAnchor="middle" fontSize="11" fill="#333">Minor strain ε₂ →</text>
        <text x={415} y={155} textAnchor="middle" fontSize="11" fill="#333" transform="rotate(-90 415 155)">Major strain ε₁ →</text>

        {/* FLC curve */}
        <path d="M 450,100 Q 560,170 650,210 Q 730,240 840,230" fill="none" stroke="#c0392b" strokeWidth="2.5"/>
        <text x={845} y={228} fontSize="11" fill="#c0392b" fontWeight="700">FLC</text>
        <text x={530} y={116} fontSize="10" fill="#c0392b">(Forming Limit Curve)</text>

        {/* Safe zone */}
        <path d="M 450,260 L 450,100 Q 560,170 650,210 Q 730,240 840,230 L 840,260 Z" fill="#1e7a36" opacity="0.08"/>
        <text x={620} y={248} textAnchor="middle" fontSize="12" fill="#27ae60" fontWeight="700">SAFE ZONE</text>

        {/* Failure zone */}
        <text x={620} y={90} textAnchor="middle" fontSize="12" fill="#c0392b" fontWeight="700">FRACTURE ZONE</text>

        {/* Process path for THF */}
        <path d="M 550,255 Q 580,230 600,200 Q 620,170 640,150" fill="none" stroke="#1e7a36" strokeWidth="2" strokeDasharray="6,3"/>
        <circle cx={640} cy={150} r={5} fill="#1e7a36"/>
        <text x={650} y={148} fontSize="10" fill="#1e7a36" fontWeight="700">THF path</text>

        {/* Wrinkle zone annotation */}
        <path d="M 450,260 L 520,260 L 520,210 L 450,160 Z" fill="#e07b00" opacity="0.12"/>
        <text x={470} y={225} fontSize="10" fill="#e07b00" fontWeight="700">WRINKLE</text>

        {/* Strain path annotations */}
        <text x={448} y={50} fontSize="10" fill="#888">plane strain</text>
        <line x1={648} y1={260} x2={648} y2={42} stroke="#888" strokeWidth="1" strokeDasharray="3,2"/>
        <text x={651} y={50} fontSize="10" fill="#888">biaxial</text>
        <line x1={440} y1={155} x2={855} y2={155} stroke="#888" strokeWidth="1" strokeDasharray="3,2" opacity="0.4"/>
      </svg>
      <div style={S.dCaption}>The forming limit diagram (FLD) maps the safe forming window in strain space. The FLC (Forming Limit Curve) separates the safe zone (below) from fracture (above). Hydroforming strain paths tend toward biaxial tension, enabling deeper forming without necking compared to uniaxial stamping. Wrinkling occurs at negative minor strains with insufficient counter-pressure.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function Hydroforming() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Hydroforming — Industrial Engineering</h1>
      <p style={S.p}>
        Hydroforming is a cost-effective metal-forming process that uses high-pressure hydraulic fluid to shape ductile metals — typically steel, aluminium, copper, and titanium — into lightweight, structurally complex hollow parts. Rather than mechanically forcing material between matched dies, hydroforming exploits the isostatic nature of fluid pressure to achieve near-net-shape components with excellent surface finish, tight tolerances, and minimal springback in a single operation.
      </p>

      <InfoBox title="Core Concepts at a Glance" items={[
        "Two main variants: tube hydroforming (THF) and sheet hydroforming (SHF) — both use hydraulic pressure as the 'die'",
        "Operating pressures: 70 – 400 MPa for tube; 50 – 1400 bar for sheet fluid cells",
        "Material yield is governed by the biaxial stress state: hoop stress σ_θ = p·r/t (thin-wall approximation)",
        "Loading path (pressure vs. axial feed) must stay within a process window to avoid burst, wrinkling, or thinning",
        "Enables 25–40% part weight reduction vs. stamped assemblies; reduces part count and number of welds",
        "Widely used in automotive (body-in-white, chassis), aerospace (Ti ducting), and structural engineering",
        "FEA (Finite Element Analysis) is essential for loading path optimisation before tooling is cut",
        "Key failure modes: burst fracture, wall thinning/necking, wrinkling/buckling — each controlled by different process parameters",
      ]}/>

      <h2 style={S.h2}>What Is Hydroforming? Process Overview</h2>
      <p style={S.p}>
        In conventional metal forming, two matched solid dies close around a blank and mechanically deform it. Hydroforming replaces one or both dies with pressurised fluid, which applies uniform force over the entire surface of the workpiece. This isostatic loading suppresses localised thinning, allows material to flow more uniformly, and produces parts with superior surface quality. The fluid medium is typically a water-oil emulsion or pure hydraulic oil.
      </p>
      <Table2 rows={[
        ["Tube hydroforming (THF)","Hollow tube is placed in a die, the die closes, then internal fluid pressure + axial end-feed expand the tube to fill the die cavity\nProduces complex hollow cross-sections: T-shapes, Y-branches, non-circular profiles"],
        ["Sheet hydroforming (SHF)","Flat blank is formed against a single punch (or form block) using fluid pressure as the counter-die\nTwo sub-types: fluid cell (diaphragm) and punch hydroforming (active fluid)"],
        ["Warm / hot hydroforming","Process carried out at elevated temperature (200–500°C for Al; 700–900°C for Ti)\nImproves ductility, reduces springback — essential for hard-to-form alloys"],
        ["High-pressure vs low-pressure","High-pressure (>100 MPa): achieves sharp radii and calibration; low-pressure (<30 MPa): pre-forming and bulge operations"],
        ["Fluid medium","Water-soluble oil emulsion (most common), neat oil, or nitrogen gas (for hot processes)\nMust be non-compressible, corrosion-resistant, and lubricating"],
      ]}/>

      <h2 style={S.h2}>Tube Hydroforming — Process Stages</h2>
      <p style={S.p}>
        Tube hydroforming proceeds in four main stages: tube preparation and bending (if required), die loading, pressurisation with simultaneous axial feed, and calibration. The calibration phase uses maximum pressure to force the tube wall into sharp die corners for dimensional accuracy.
      </p>
      <DiagramTubeHydroforming/>

      <h2 style={S.h2}>Sheet Hydroforming — Fluid Cell and Punch Processes</h2>
      <p style={S.p}>
        Sheet hydroforming is used for panel components — automotive body panels, aerospace skins, and medical housings. The fluid cell process is particularly attractive because it requires only a single positive tool (no matched lower die), dramatically cutting tooling cost for low-to-medium volumes.
      </p>
      <DiagramSheetHydroforming/>

      <h2 style={S.h2}>Loading Path Optimisation & Failure Modes</h2>
      <p style={S.p}>
        The most critical engineering challenge in tube hydroforming is selecting the correct loading path — the trajectory of internal pressure versus axial feed over time. The path must remain inside a narrow process window. FEA simulation of the forming process is now standard practice before any physical tooling is manufactured.
      </p>
      <DiagramLoadingPath/>
      <Table2 rows={[
        ["Burst / fracture","Caused by excessive internal pressure relative to axial feed\nMaterial exceeds its forming limit — wall ruptures; prevented by increasing feed rate or reducing pressure ramp"],
        ["Wrinkling / buckling","Caused by excessive axial feed relative to internal pressure\nExcess material piles up and buckles inward; prevented by increasing back-pressure"],
        ["Wall thinning / necking","Localised thinning at expansion zones; exacerbated by insufficient feed or high L/D ratio\nMonitored by thickness strain — kept below 10–15% of original wall"],
        ["Springback","Elastic recovery after unloading — less severe than stamping due to biaxial stress state\nMinimised by calibration phase at maximum pressure"],
        ["Calibration phase","Final stage at maximum pressure — forces tube wall into die corner radii\nAchieves tolerances of ±0.1 mm; radius as small as 1×wall thickness"],
        ["Counter-pressure (SHF)","Fluid pressure beneath sheet in punch hydroforming delays necking\nOptimal counter-pressure = 30–50% of material yield strength × thickness"],
      ]}/>

      <h2 style={S.h2}>Stress State & Forming Limits</h2>
      <p style={S.p}>
        Understanding the multi-axial stress state in hydroformed parts is essential for predicting formability. Unlike stamping (primarily uniaxial tension), hydroforming imposes a biaxial stress state — hoop stress and axial stress are both tensile, while radial stress equals the compressive fluid pressure. This biaxial loading exploits a larger portion of the material's plastic deformation capacity.
      </p>
      <DiagramStressState/>
      <Table2 rows={[
        ["Hoop stress σ_θ","σ_θ = p·r/t   (thin-wall Lamé approximation)\nCircumferential tensile stress — drives tube expansion"],
        ["Axial stress σ_z","Controlled by axial punch force; tensile during feed, compressive if over-fed\nσ_z = F_axial / (π·D·t)"],
        ["Radial stress σ_r","Equal to −p (compressive) at inner wall; zero at outer wall\nOften neglected for thin-wall tubes (t/r < 0.1)"],
        ["Von Mises criterion","Yielding when: σ_θ² − σ_θσ_z + σ_z² = σ_y²\nDetermines onset of plastic flow — must be exceeded throughout forming"],
        ["Forming Limit Curve (FLC)","Empirical curve in (ε_minor, ε_major) space separating safe forming from fracture\nDetermined by Nakajima or Marciniak test specimens"],
        ["Strain path (THF)","Biaxial tension (positive ε₁, positive ε₂) during expansion\nDiffers from stamping (ε₁ positive, ε₂ negative) — FLC values are higher"],
        ["Anisotropy (r-value)","Planar anisotropy affects material flow direction\nHigh r-value materials (aluminium alloys ≈ 0.6–0.8; HSLA steel ≈ 1.0–1.5) resist thinning differently"],
      ]}/>

      <h2 style={S.h2}>Materials Used in Hydroforming</h2>
      <Table2 rows={[
        ["Low-carbon / mild steel","Most common — low cost, excellent ductility (≈40% elongation), easy to weld\nUsed for automotive structural tubes at thicknesses 1.0–3.0 mm"],
        ["High-strength low-alloy (HSLA)","Yield strength 350–700 MPa — enables thinner walls for same load capacity\nMore springback; needs higher calibration pressure"],
        ["Advanced high-strength steel (AHSS)","DP, TRIP, CP steels: UTS 600–1500 MPa — challenging to hydroform\nRequires warm processing or very precise loading path control"],
        ["Aluminium alloys (5xxx, 6xxx)","Low density (2.7 g/cm³), good corrosion resistance; ductility lower than steel\n6061-T4 and 5182 most common; warm/hot forming improves formability"],
        ["Titanium alloys (Ti-6Al-4V)","High strength-to-weight, excellent corrosion resistance; poor room-temperature ductility\nRequires hot hydroforming (700–900°C) in heated dies with inert atmosphere"],
        ["Stainless steel (304, 316)","High work-hardening rate — limits expansion ratio\nUsed for exhaust, medical, food-processing components"],
        ["Copper / brass","Excellent ductility; used for plumbing fittings and heat exchangers\nLow yield strength — requires less pressure than steel"],
      ]}/>

      <h2 style={S.h2}>Tooling & Equipment</h2>
      <Table2 rows={[
        ["Hydroforming press","Provides clamping force to hold die halves closed against internal pressure\nForce: F_clamp = p × projected area; typically 10–100 MN for tube dies"],
        ["Die materials","H13 / D2 tool steel (hardened to 52–56 HRC); Ductile iron for prototypes\nDie surface ground to Ra 0.4–0.8 µm; TiN/TiCN coatings reduce galling"],
        ["Axial punch / intensifier","Seals tube ends and feeds material axially; also injects pressurising fluid\nMust exert up to 10 MN; must maintain seal under 400 MPa internal pressure"],
        ["Pressure intensifier","Boosts hydraulic pump output (typically 30 MPa) to process pressure (up to 400 MPa)\nHydraulic amplification ratio 10:1 to 15:1; controlled by CNC servo-valve"],
        ["CNC control system","Closed-loop PID control of pressure ramp and axial feed simultaneously\nSynchronised to within ±0.5 MPa and ±0.1 mm for repeatability"],
        ["Pre-bending tooling","For non-straight tubes: rotary draw bending (RDB) prebends tube before THF\nBend radius typically ≥ 1.5×D; mandrel bending prevents collapse"],
        ["Sealing technology","O-ring face seals or mechanical taper seals at axial punch–tube interface\nMust withstand rapid pressure cycling — critical maintenance item"],
        ["Fluid handling","High-pressure pump, reservoir, filters (25 µm), heat exchanger, and pressure relief valves\nFluid temperature controlled to 20–40°C for consistent viscosity"],
      ]}/>

      <h2 style={S.h2}>Applications & Industries</h2>
      <p style={S.p}>
        Hydroforming is most valuable when part complexity, weight targets, or weld-joint reduction justifies its higher capital cost relative to stamping. Automotive applications dominate, but aerospace, structural, medical, and industrial sectors are growing rapidly.
      </p>
      <DiagramApplications/>
      <Table2 rows={[
        ["Automotive body-in-white","A-pillars, B-pillars, roof rails, door sills — hydroformed HSLA saves 2–4 kg per vehicle\nBMW, Audi, GM, Ford use extensive THF in space-frame architectures"],
        ["Automotive chassis/suspension","Rear axle carriers, sub-frame rails, control arms — complex 3D shapes with variable cross-section\nEliminate up to 80% of assembly welds vs. fabricated alternatives"],
        ["Exhaust systems","Hydroformed manifolds and collectors replace cast iron — 40% weight saving\nUniform wall thickness improves thermal performance and durability"],
        ["Aerospace ducting","Titanium and aluminium ducts for hydraulic, pneumatic, fuel systems\nTighter tolerances than welded tube assemblies; no weld HAZ degradation"],
        ["Bicycle & sporting frames","Aluminium and titanium frame tubes with variable cross-section for optimised stiffness-to-weight\nTrek, Specialized, Cannondale use THF extensively"],
        ["Architectural tubing","Stainless steel and aluminium structural tubing for facades, handrails, furniture\nSeamless appearance, complex swept curves without visible welds"],
        ["Medical devices","304/316L stainless components for surgical instruments and implant housings\nHighly controlled dimensional tolerances; no post-weld cleaning required"],
      ]}/>

      <h2 style={S.h2}>Advantages, Limitations & Process Selection</h2>
      <DiagramComparison/>
      <Table2 rows={[
        ["✔ Part consolidation","Multiple stamped + welded parts replaced by single hydroformed component\nTypical: 6–8 stampings + welding → 1 THF part; reduces assembly cost and error stack-up"],
        ["✔ Weight reduction","Thinner walls achievable due to strain hardening during forming; 25–40% mass saving vs fabricated parts\nCritical for automotive fuel economy and aerospace payload capacity"],
        ["✔ Dimensional accuracy","Springback is lower than stamping (biaxial residual stress state balances out)\nTolerances of ±0.1–0.3 mm routinely achieved after calibration"],
        ["✔ Surface quality","No tool marks on inner surface (fluid contact); outer surface Ra 0.8–1.6 µm\nReduces or eliminates post-process finishing for visible components"],
        ["✔ Increased stiffness","Work-hardening during forming increases yield strength by 15–30%\nClosed hollow section has superior bending/torsional stiffness vs. open profiles"],
        ["✗ High tooling cost","Matched precision die sets for THF: $150k–$500k+; long lead times\nOnly economic above 5,000–50,000 parts/year depending on complexity"],
        ["✗ Long cycle time","Pressure build, hold, release, and die open/close: 20–120 seconds per part\n10–30× slower than progressive stamping at equivalent complexity"],
        ["✗ Fluid management","High-pressure fluid system requires maintenance, filtration, and fluid disposal\nLeak detection and pressure relief safety systems add cost and complexity"],
        ["✗ Pre-form requirements","Tubes often require pre-bending and annealing; sheet blanks require precise edge preparation\nAdds upstream process steps and capital equipment"],
      ]}/>

      <h2 style={S.h2}>Design for Hydroforming — Key Guidelines</h2>
      <Table2 rows={[
        ["Expansion ratio","Circumferential expansion should not exceed 25–30% for steel; 20–25% for aluminium\nHigher ratios risk burst fracture — verify with FEA and FLC analysis"],
        ["Corner radii","Minimum inner radius ≈ 1.0–1.5 × wall thickness after calibration\nTighter radii require higher calibration pressure — check die clamping capacity"],
        ["Wall thickness","Starting wall thickness: 1.0–4.0 mm for automotive; 0.5–2.0 mm for aerospace\nDesign wall thinning < 10%; thickening in feed zones to 115–125% of nominal"],
        ["Tube L/D ratio","L/D < 8 for single-step forming; longer tubes require intermediate annealing or stepped dies\nHigh L/D → friction and buckling risk; lubricant selection critical"],
        ["Draft angles","Unlike casting/injection moulding, hydroforming requires no draft — enables undercuts\nDie split-line placement is key to part removal — avoid parting flash at critical surfaces"],
        ["Pre-bend radius","For pre-bent tubes: bend radius ≥ 1.5D (draw bend) or ≥ 2.5D (push bend)\nTighter pre-bends require mandrel bending and post-bend annealing"],
        ["Lubrication","Low-viscosity oil or emulsion sprayed into tube interior; die surfaces coated or lubricated\nFriction coefficient µ ≈ 0.04–0.12 in THF — critical for uniform material flow"],
        ["Material selection","Choose material with high n-value (strain hardening) and high r-value (resistance to thinning)\nDP600 and 6061-T4 are workhorses; avoid high-carbon or low-ductility grades"],
      ]}/>

      <h2 style={S.h2}>Simulation & Process Development</h2>
      <Table2 rows={[
        ["FEA software","LS-DYNA, ABAQUS, AutoForm, PAM-STAMP widely used for THF simulation\nExplicit dynamic solvers handle high-speed pressure loading; implicit for quasi-static"],
        ["Material models","Barlat Yld2000-2d or Hill48 for anisotropy; Swift-Voce hardening laws for work-hardening\nAccurate material data (tensile test + biaxial bulge test) essential for prediction accuracy"],
        ["Loading path optimisation","Iterative FEA: adjust pressure vs. feed profile to keep strains inside FLC\nAdaptive control algorithms (model predictive control) increasingly used in production"],
        ["Die structural analysis","Die must withstand internal pressure reaction force without deflection > 0.05 mm\nFEA of die structure in parallel with forming simulation"],
        ["Physical try-out","After FEA, 3–5 try-out iterations typical before production approval\nMeasure wall thickness (ultrasonic), geometry (CMM), and surface for wrinkles/cracks"],
        ["Digital twin","Real-time process monitoring + FEA model calibration for SPC (statistical process control)\nPressure, feed, and temperature sensors feed adaptive process correction"],
      ]}/>

      <h2 style={S.h2}>Advanced & Emerging Hydroforming Variants</h2>
      <Table2 rows={[
        ["Warm/hot hydroforming","Workpiece heated before and/or during forming; fluid replaced by gas (N₂) or heated oil\nAluminium: 200–300°C; Titanium: 700–900°C — 2–3× improvement in formability"],
        ["Electromagnetic-assisted HF","Electromagnetic coil creates Lorentz force in addition to fluid pressure\nHelps fill sharp die corners and reduces springback; research/prototype stage"],
        ["Hydroforming of tailored tubes","Laser-welded blanks (TWBs) of different thicknesses/grades formed in one die\nOptimises material distribution — thicker where stiffness needed, thinner elsewhere"],
        ["Internal high-pressure forming (IHF)","General European term encompassing THF; emphasises fluid as active forming tool\nDistinguished from conventional deep drawing by use of closed dies"],
        ["Rubber-pad forming","Polyurethane pad replaces fluid in sheet forming — lower pressure (< 100 bar)\nSimpler equipment; used for low-volume aerospace panels"],
        ["Incremental sheet HF","Localised fluid jet/nozzle scans over sheet surface — very small tool contact\nFor highly complex, ultra-low volume parts; slow but extremely flexible"],
        ["Hydroforming of composites","Thermoplastic composite preforms consolidated under hydraulic pressure in heated dies\nReduces void content vs. autoclave; emerging in aerospace and automotive"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Hoop stress (thin-wall): σ_θ = p·r/t   [p = pressure (MPa), r = mean radius (mm), t = wall thickness (mm)]",
        "Axial stress: σ_z = F_axial / (π·D·t)   [F = punch force (N), D = mean diameter (mm)]",
        "Von Mises yield criterion: σ_θ² − σ_θσ_z + σ_z² = σ_y²   (onset of plastic flow)",
        "Die clamping force: F_clamp = p_internal × A_projected   (must exceed internal pressure load)",
        "Expansion ratio: e = (C_final − C_initial) / C_initial × 100%   (keep < 25–30% for steel)",
        "Pressure amplification: p_out / p_in = A_in / A_out   (intensifier ratio, typically 10:1–15:1)",
        "Wall thinning: Δt/t₀ = ε_r (radial true strain) — keep below 10–15% of original thickness",
        "Pre-bend minimum radius: R_min ≥ 1.5 × D_tube   (for mandrel draw bending)",
      ]}/>
    </div>
  );
}